<template>
    <v-dialog v-model="dialog" max-width="500px">
        <template v-slot:activator="{ on }">
            <v-btn dark text color="blue-grey accent-4" v-on="on">
                로그인
            </v-btn>
        </template>
        <v-card max-width="500" class="mx-auto">
            <v-card-title class="ma-3">
                <h3 class="title blue-grey--text text--accent-4">로그인</h3>
            </v-card-title>
            <v-card-text>
                <v-form class="px-3" v-model="valid" ref="signupForm">
                    <v-text-field
                        type="email"
                        v-model="email"
                        label="이메일"
                        hint="ex) pingpong@pingpong.com"
                        :rules="emailRules">
                    </v-text-field>
                    <v-text-field
                        type="password"
                        v-model="password"
                        label="비밀번호"
                        :rules="passwordRules">
                    </v-text-field>
                     <p class="text-center caption pink--text" v-if="feedback">{{ feedback }}</p>
                    <v-row justify="center">
                        <v-btn :loading="loading" class="mt-5 white--text" color="blue-grey accent-4" @click="login" :disabled="!valid">Log in</v-btn>
                    </v-row>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/auth';

export default {
    name: 'Login',
    data: () => ({
        dialog: false,
        loading: false,
        valid: false,
        email: '',
        feedback: null,
        emailRules: [
            v => !!v || '이메일은 꼭 필요해요!',
            v => /.+@.+/.test(v) || '제대로 된 이메일 주소를 입력해 주세요!',
        ],
        password: '',
        passwordRules: [
            v => !!v || '비밀번호는 꼭 필요해요!',
            v => v.length >= 8 || '8자는 넘어야 해요!',
        ],
    }),
    methods: {
        login() {
            this.loading = true;
            firebase.auth().signInWithEmailAndPassword(this.email, this.password)
                .then(() => {
                    this.dialog = false;
                    this.loading = false;
                    location.reload();
                    // this.$router.push({ name: 'MyPage'})
                }).catch(err => {
                    this.feedback = err.message
                    this.loading = false;
                })
            
        }
    }
}
</script>